import React, { Component, Fragment } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import DashboardIcon from '../icons/DashboardIcon';
import AccountIcon from '../icons/AccountIcon';
import MenuIcon from '../icons/MenuIcon';
import CloseIcon from '../icons/CloseIcon';
import SiteLogoIcon from '../icons/SiteLogoIcon';

class Navbar extends Component {
  navLinkProps = {
    onClick: this.toggleNav,
    activeClassName: 'nav--active',
  }

  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  toggleNav = () => {
    this.setState(prevState => ({ expanded: !prevState.expanded }));
  }

  logout = (e) => {
    const { usersActions } = this.props;
    e.preventDefault();
    this.toggleNav();
    usersActions.logout();
    // Send message to other tabs to log out as well
    localStorage.setItem('logout', Date.now());
  }

  render() {
    const { loggedIn } = this.props;
    const { expanded } = this.state;
    return (
      <nav className="nav">
        <div className="row">
          <div className="nav__wrapper">
            <Link to="/">
              <SiteLogoIcon />
            </Link>
            <div className="nav__buttons">
              {loggedIn
                ? (
                  <Fragment>
                    <Link to="/" className="nav__dashboard-link">
                      <DashboardIcon />
                    </Link>
                    <Link to="/account" className="nav__account-link">
                      <AccountIcon />
                    </Link>
                  </Fragment>
                ) : (
                  <Link to="/login" className="button nav__login">
                    Log In
                  </Link>
                )
              }
              <button
                type="button"
                onClick={this.toggleNav}
                className="nav__button nav__button--menu"
              >
                <MenuIcon />
              </button>
            </div>
            <CSSTransition
              classNames="transition"
              timeout={200}
              in={expanded}
              mountOnEnter
              unmountOnExit
            >
              <div className="nav__sidebar">
                <ul className="nav__links">
                  <li className="nav__link">
                    <button
                      type="button"
                      onClick={this.toggleNav}
                      className="nav__button nav__button--close"
                    >
                      <CloseIcon />
                    </button>
                  </li>
                  <li className="nav__link">
                    <NavLink exact to="/" {...this.navLinkProps}>
                      Home
                    </NavLink>
                  </li>
                  <li className="nav__link">
                    <NavLink to="/about" {...this.navLinkProps}>
                      About
                    </NavLink>
                  </li>
                  <li className="nav__link">
                    <NavLink to="/assessments" {...this.navLinkProps}>
                      Assessments
                    </NavLink>
                  </li>
                  <li className="nav__link">
                    <NavLink to="/reference-list" {...this.navLinkProps}>
                      Reference List
                    </NavLink>
                  </li>
                  <li className="nav__link">
                    <NavLink to="/account" {...this.navLinkProps}>
                      Manage Account
                    </NavLink>
                  </li>
                  <li className="nav__link">
                    <NavLink to="/privacy-policy" {...this.navLinkProps}>
                      Privacy Policy
                    </NavLink>
                  </li>
                  {loggedIn
                    ? (
                      <li className="nav__link nav__link--sub">
                        <Link to="/" onClick={this.logout}>
                          Log Out
                        </Link>
                      </li>
                    ) : (
                      <li className="nav__link nav__link--sub">
                        <NavLink to="/login" {...this.navLinkProps}>
                          Log In
                        </NavLink>
                        {' / '}
                        <NavLink to="/register" {...this.navLinkProps}>
                          Create Account
                        </NavLink>
                      </li>
                    )
                  }
                </ul>
              </div>
            </CSSTransition>
            {expanded && <div className="nav__sidebar-overlay" onClick={this.toggleNav} />}
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/common/Navbar.js